module.exports = __webpack_public_path__ + "media/images/mailer/shopping_cart-48-white-29630a83dd2d09f4dd853f997ead17ce.png";